import clsx from 'clsx';
import type { FunctionComponent, HTMLAttributes, ReactNode } from 'react';

export type IconIndicatorProps = HTMLAttributes<HTMLDivElement> & {
    readonly children: ReactNode;
    readonly size?: 'm' | 'sm';
    readonly variant?: 'default' | 'highlighted';
};

const sizeClasses = {
    m: 'h-8xl w-8xl',
    sm: 'h-7xl w-7xl',
} as const;

const variantClasses = {
    default: 'bg-surface-subtle text-text-content-faint',
    highlighted: 'bg-indicator-highlighted-surface text-indicator-highlighted-icon',
} as const;

export const IconIndicator: FunctionComponent<IconIndicatorProps> = ({
    children,
    className,
    size = 'sm',
    variant = 'default',
    ...props
}) => {
    return (
        <div
            className={clsx(
                'flex items-center justify-center shrink-0 rounded-md transition-[background,color] duration-200 ease-in-out',
                '[&_svg]:h-3xl [&_svg]:w-3xl',
                sizeClasses[size],
                variantClasses[variant],
                className,
            )}
            style={{ boxShadow: 'var(--shadow-icon-indicator)' }}
            {...props}
        >
            {children}
        </div>
    );
};
